import * as React from 'react';
import { Overlay, SideModal, SideModalContent } from '~/common/layout/Modals';
import Head from '~/common/layout/Head';

import UserCreateForm from './UserCreateForm';

export default (props) => {
  const { headTitle, onClose, onSubmit, user, locations, errorMessage } = props;

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <Overlay onClick={handleClose}>
      <SideModal>
        <Head headTitle={headTitle} />

        <SideModalContent>
          <UserCreateForm
            onSubmit={onSubmit}
            initialValues={user}
            error={errorMessage}
            locations={locations}
          />
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};
